import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CardIcon',
  props: {
    kind: {}
  },
  setup(__props: any) {

const props = __props;

const iconName = computed(() => {
  if (props.kind === 'track') return 'location-o';
  if (props.kind === 'linked') return 'shield-o';
  return 'close';
});

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card-icon", `card-icon--${_ctx.kind}`])
  }, [
    _createVNode(_component_van_icon, {
      name: iconName.value,
      size: "20",
      color: "#007AFF"
    }, null, 8, ["name"])
  ], 2))
}
}

})